<template>
    <div class="d-block w-100" v-if="pickerData">
        <transition name="picker-fade">
            <div class="picker" @touchmove.prevent>
                <transition name="picker-move">
                    <div class="picker-panel" v-show="state===1" @click.stop>
                        <div class="picker-content">
                            <div class="mask-top border-bottom-1px"></div>
                            <div class="mask-bottom border-top-1px"></div>
                            <div class="wheel-wrapper" ref="wheelWrapper">
                                <div class="wheel">
                                    <ul class="wheel-scroll">
                                        <li
                                            v-for="(item, index) in pickerData" :key="index"
                                            :class="{'wheel-disabled-item':item.disabled}"
                                            class="wheel-item" v-html="item.text"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="picker-footer"></div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script type="text/ecmascript-6">
import BScroll from '@better-scroll/core'
import Wheel from '@better-scroll/wheel'
BScroll.use(Wheel)

const STATE_HIDE = 0
const STATE_SHOW = 1

const COMPONENT_NAME = 'picker'
const EVENT_SELECT = 'select'
const EVENT_CHANGE = 'change'
const WHEEL_INDEX_CHANGED = 'wheelIndexChanged'

const DATA = [
    {
        text: 'Venomancer',
        value: 1,
        // disabled: 'wheel-disabled-item'
    }, {
        text: 'Nerubian Weaver',
        value: 2
    },
    {
        text: 'Spectre',
        value: 3
    }
]

export default {
    name: COMPONENT_NAME,
    props: {
        items: {
            type: Array|Object,
            required: true,
        },
        selected: {
            required: false,
        }
    },
    data() {
        return {
            state: STATE_HIDE,
            pickerData: this.items,
            selectedIndex: this.getSelectedIndex(),
            selectedText: 'open',
        }
    },
    methods: {
        getSelectedIndex() {
            let selectedIndex;
            selectedIndex = this.items.findIndex(item => item.value === this.selected.value);
            return selectedIndex === -1 ? 0 : selectedIndex;
        },
        _confirm() {
            const currentSelectedIndex = this.selectedIndex = this.wheel.getSelectedIndex()
            this.selectedText = `${this.pickerData[currentSelectedIndex].text}-${currentSelectedIndex}`;
            let option = this.items[currentSelectedIndex];
            this.$emit(EVENT_SELECT, option)
        },
        show() {
            if (this.state === STATE_SHOW) {
                return
            }
            this.state = STATE_SHOW
            if (!this.wheel) {
                // waiting for DOM rendered
                this.$nextTick(() => {
                    if (this.$refs.wheelWrapper && this.$refs.wheelWrapper.children.length > 0) {
                        const wrapper = this.$refs.wheelWrapper.children[0];
                        this._createWheel(wrapper);
                    }
                })
            }
        },
        _createWheel(wheelWrapper) {
            if (!this.wheel) {
                this.wheel = new BScroll(wheelWrapper, {
                    wheel: {
                        selectedIndex: this.selectedIndex,
                        wheelWrapperClass: 'wheel-scroll',
                        wheelItemClass: 'wheel-item',
                        wheelDisabledItemClass: 'wheel-disabled-item'
                    },
                    useTransition: false,
                    probeType: 3
                })
                // < v2.1.0
                this.wheel.on('scrollEnd', () => {
                    this.$emit(EVENT_CHANGE, this.wheel.getSelectedIndex())
                })
                // v2.1.0, only when selectedIndex changed
                this.wheel.on(WHEEL_INDEX_CHANGED, (index) => {
                    this._confirm();
                })
            } else {
                this.wheel.refresh()
            }
            return this.wheel
        }
    },
    mounted() {
        setTimeout(() => {
            this.show();
        }, 350);
    }
}
</script>
